import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class Currency extends ApplicationRecord {
  static jsonapiType = "currencies";

  @Attr() isoCode: string;

  @Attr() symbol: string;

  get label() {
    return `${this.symbol} ${this.isoCode}`;
  }
}

export default Currency;
